<!-- 录用条件确认书对话框 -->
<template>
    <el-dialog v-model="showDialog" @open="handleOpen" title="录用条件确认书"  class="diglog" width="90%"  center :lock-scroll="false"><!-- 子组件维护对话框显隐 -->
        <template #header="{ close, titleId, titleClass }">
            <div class="my-header">
                <h4 style="font-size: 0.5rem; text-align: right;vertical-align: text-top;">ver 2.00</h4>
                <h4 :id="titleId" :class="titleClass" style="font-size: 2rem; color: #0D2EA0;">录用条件确认书</h4>
                
            </div>
        </template>
        <el-scrollbar height="25rem">
        <div>
            <h3 class="h3Css">岗位录用条件：</h3>
            <h3 class="h3Css">一、思想品德方面</h3>
            <p class="fontCss">
                诚实守信是优良的道德品质。试用期内员工提供给公司的个人信息存在任何或其它事实上的虚假陈述、虚假材料的行为属于不符合录用条件（包含但不限于入职时提供的学历学位证书、工作经历、体检证明、离职证明材料等，也包括工作中向上级提交的虚假材料及传达、汇报的虚假信息）。					
            </p>
            <h3 class="h3Css">二、遵纪守法方面</h3>	
            <p class="fontCss">（1）遵守国家法律法规，出现违反国家法律法规禁止行为的，属于不符合录用条件。</p>	
            <p class="fontCss">（2）遵守公司规章制度，出现违反公司规章制度的、违反禁止行为一览表的，属于不符合录用条件。</p>	
            <h3 class="h3Css">三、身心健康状态方面</h3>
            <p class="fontCss">身心健康状态方面出现下列情形之一的，属于不符合录用条件：</p>
            <p class="fontCss">（1）不能接受公司正常业务需要、紧急业务需要所安排的夜班或站立作业等情形。</p>
            <p class="fontCss">（2）身体健康状态不能承受公司安排的日常工作等情形。</p>
            <p class="fontCss">（3）公司正常安排工作所带来的工作压力下，不能保持情绪稳定，无法做好本职工作的情形。</p>
            <h3 class="h3Css">四、工作态度方面</h3>
            <p class="fontCss">工作态度方面出现下列情形之一的，属于不符合录用条件：</p>
            <p class="fontCss">（1）缺乏敬业精神、团队合作精神与工作责任心。</p>
            <p class="fontCss">（2）不能严格按照部门制定的作业指导书操作，未经上司许可，擅自变更工作流程、工作方法。</p>
            <p class="fontCss">（3）不能接受公司、部门内部正当工作岗位调整。</p>
            <p class="fontCss">（4）对于工作中的失误，隐瞒不报，或不能接受上司、同事正确指导，且态度恶劣。</p>
            <p class="fontCss">（5）缺乏客户服务意识、他部门协作配合意识，被客户、他部门投诉。</p>
            <p class="fontCss">（6）玩忽职守，不履行应尽的职责义务，给公司、客户带来直接或间接经济损失。</p>
            <h3 class="h3Css">五、技术水平、工作能力方面	</h3>
            <p class="fontCss">技术水平、工作能力方面出现下列情形之一的，属于不符合录用条件：</p>
            <p class="fontCss">（1）不具备或欠缺适应本岗位所应掌握和具备的专业知识与技能。</p>
            <p class="fontCss">（2）在规定时间内，无法完成既定工作或工作效率低于岗位正常水平。</p>
            <p class="fontCss">（3）工作成果不符合公司制定的质量合格标准，工作成果合格率低于公司规定的合格率（合格标准及合格率详见公司各部门制定发行的相关工作成果合格标准或合格率标准文件）。						
            </p>
            <p class="fontCss">（4）技术水平、工作能力不足，经培训教育或岗位调整后仍不能胜任现有或调整后工作。 
            </p>
            <p class="fontCss">（5）不能及时将工作中发现的异常情形向上司汇报或未能及时、有效按照上司制定的问题解决方案予以实施。						
            </p>
            <h3 class="h3Css">本录用条件确认书与《劳动合同》具有同等法律效力。</h3>		
            
            </div>
            
        </el-scrollbar>
        <!-- <el-button @click="$emit('confirm','123123')">Confirm</el-button> -->
        <template #footer>
            <span class="dialog-footer">
                <el-button type="primary"  style="float: none; width: 120px;" @click="showDialog = false">
                确定
                </el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script>
 export default {
    data() {
        return {
            showDialog: false,
        }
    },
    methods: {
        show(){
            this.showDialog = true;
            this.$nextTick(()=> {
                // this.$refs.table.query() // el-dialog懒渲染，需要使用nextTick初始化数据
            });
        },
        handleOpen(){ // 由于el-dialog懒渲染，或使用官方提供的open回调
            //this.$refs.table.query() // 这样，第一次打开就能获取到this.$refs.的内容了
        }
    }
}
</script>
<style scoped>
    .fontCss{
        line-height: 1.2rem;
        font-size: 1.2rem;
        padding: 5px 0;
        text-indent:2rem;
    }
    .h3Css{
        line-height: 1.4rem;
        font-size: 1.4rem;
        padding: 5px 0;
        text-indent:2rem;
        font-weight: bold;
    }

</style>